import { Badge, BadgeVariant } from 'src/components/Badge';

export enum CampaignBadgeStatus {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  RUNNING = 'running',
  STOPPED = 'stopped',
}

interface CampaignBadgeProps {
  status: CampaignBadgeStatus;
  className?: string;
}

const statusConfig: Record<
  CampaignBadgeStatus,
  { variant: BadgeVariant; color: string; label: string }
> = {
  [CampaignBadgeStatus.DRAFT]: {
    variant: 'info',
    color: 'bg-info',
    label: 'Draft',
  },
  [CampaignBadgeStatus.SCHEDULED]: {
    variant: 'warning',
    color: 'bg-warning',
    label: 'Scheduled',
  },
  [CampaignBadgeStatus.RUNNING]: {
    variant: 'success',
    color: 'bg-success',
    label: 'Running',
  },
  [CampaignBadgeStatus.STOPPED]: {
    variant: 'error',
    color: 'bg-error',
    label: 'Stopped',
  },
};

export const CampaignBadge = ({
  status,
  className = '',
}: CampaignBadgeProps) => {
  const config = statusConfig[status];

  return (
    <Badge
      variant={config.variant}
      className={`flex items-center gap-1 ${className}`}
    >
      <div className={`w-2 h-2 ${config.color} rounded-full`}></div>
      {config.label}
    </Badge>
  );
};
